// getIsAesEncrypted.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getAssetData from '../selector/getAssetData.js';

/**
 * Select is aes encrypted by asset id.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} assetId - asset id.
 * @return {boolean} The selected is aes encrypted.
 */
const getIsAesEncrypted = createCachedSelector(
  (state, assetId) => {
    return getAssetData(state, [assetId], 'aes');
  },
  aes => !!aes
)((state, assetId) => `getIsAesEncrypted:${assetId}`);

export default getIsAesEncrypted;
